<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemesEditNotesRouter',
};
</script>
